import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const placesWithChaptersListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, place) => <>{place?.id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => <>{place?.name}</>,
    },
    {
      text: "Chapter",
      dataField: "chapter",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => <>{place?.chapter}</>,
    },
    {
      text: "Address",
      dataField: "address",
      formatter: (cellContent, place) => (
        <>
          {place?.address_street_1}, {place?.city}, {place?.state},{" "}
          {place?.country_code}
        </>
      ),
    },
  ]
}

export default placesWithChaptersListColumns
